"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGroupEnrollmentSchema = exports.groupEnrollmentSchema = exports.updateGroupSessionSchema = exports.createGroupSessionSchema = exports.groupSessionSchema = void 0;
// Legacy group-shaped schema kept as an alias view over the unified Resource
// model. The /group-sessions API returns Resource rows where type=GROUP,
// mapped to this shape for the existing frontend.
const zod_1 = require("zod");
const enums_js_1 = require("../enums.js");
const localDate_js_1 = require("../localDate.js");
exports.groupSessionSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    serviceType: zod_1.z.enum(enums_js_1.GroupServiceTypes),
    displayName: zod_1.z.string(),
    days: zod_1.z.array(zod_1.z.enum(enums_js_1.DayOfWeeks)),
    startMin: localDate_js_1.timeMinSchema,
    endMin: localDate_js_1.timeMinSchema,
    placeOfService: zod_1.z.enum(enums_js_1.PlacesOfService),
    maxClients: zod_1.z.number().int().positive(),
    minStaff: zod_1.z.number().int().min(0),
    active: zod_1.z.boolean(),
    staffAssignments: zod_1.z.array(zod_1.z.object({ providerId: zod_1.z.string().uuid() })),
    roomResourceId: zod_1.z.string().uuid().nullable().optional(),
    roomName: zod_1.z.string().nullable().optional(),
    enrollmentCount: zod_1.z.number().int().min(0).optional(),
});
exports.createGroupSessionSchema = zod_1.z.object({
    serviceType: zod_1.z.enum(enums_js_1.GroupServiceTypes),
    displayName: zod_1.z.string().min(1),
    days: zod_1.z.array(zod_1.z.enum(enums_js_1.DayOfWeeks)).min(1),
    startMin: localDate_js_1.timeMinSchema,
    endMin: localDate_js_1.timeMinSchema,
    placeOfService: zod_1.z.enum(enums_js_1.PlacesOfService),
    maxClients: zod_1.z.number().int().positive().default(24),
    minStaff: zod_1.z.number().int().min(0).default(1),
    staffProviderIds: zod_1.z.array(zod_1.z.string().uuid()).default([]),
    roomResourceId: zod_1.z.string().uuid().optional(),
});
exports.updateGroupSessionSchema = exports.createGroupSessionSchema.partial().extend({
    active: zod_1.z.boolean().optional(),
});
exports.groupEnrollmentSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    clientId: zod_1.z.string().uuid(),
    groupResourceId: zod_1.z.string().uuid(),
    enrolledDays: zod_1.z.array(zod_1.z.enum(enums_js_1.DayOfWeeks)),
    startDate: localDate_js_1.localDateSchema,
    endDate: localDate_js_1.localDateSchema.nullable().optional(),
});
exports.createGroupEnrollmentSchema = zod_1.z.object({
    clientId: zod_1.z.string().uuid(),
    // Optional in the body — the controller injects it from the URL param.
    groupResourceId: zod_1.z.string().uuid().optional(),
    enrolledDays: zod_1.z.array(zod_1.z.enum(enums_js_1.DayOfWeeks)).optional(),
    startDate: localDate_js_1.localDateSchema.optional(),
    endDate: localDate_js_1.localDateSchema.optional(),
});
//# sourceMappingURL=group.js.map